import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import RemoteJob from "../features/remote_job";

/* REMOTE JOB */
export const remoteJobRoutes = (
    <Route
        path={ROUTES.remote_job.home}
        element={<RemoteJob />}
        key="remote_job"
    />
);
